//Built-in libraries

import { formatDate3 } from '@/utils';

//Third party libraries

//Custom components

//Services

//STP Libraries

//Assets and Miscellaneous

//Component Begin

interface IDevelopmentScheduleDetailsProps {
  developmentSchedule: any;
}
export default function DevelopmentSchedule({ developmentSchedule }: IDevelopmentScheduleDetailsProps) {
  const { schedule1, schedule2, schedule3, schedule4, schedule5 } = developmentSchedule;
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              Development Schedule
            </h2>
            <p className='mt-1 max-w-2xl text-sm text-gray-500'>Anticipated Development Schedule</p>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mb-5'>
            <div className='sm:col-span-2 grid grid-cols-6'>
              <dt className='col-span-3 text-neutralColor-normal'>Acquisition</dt>
              <dd className='col-span-3 space-x-4'>
                <span>Start Date: {schedule1.startDate ? formatDate3(schedule1.startDate) : 'None'}</span>
                <span>Finish Date: {schedule1.finishDate ? formatDate3(schedule1.finishDate) : 'None'}</span>
              </dd>
            </div>
            <div className='sm:col-span-2 grid grid-cols-6'>
              <dt className='col-span-3 text-neutralColor-normal'>Financial Close</dt>
              <dd className='col-span-3 space-x-4'>
                <span>Start Date: {schedule2.startDate ? formatDate3(schedule2.startDate) : 'None'}</span>
                <span>Finish Date: {schedule2.finishDate ? formatDate3(schedule2.finishDate) : 'None'}</span>
              </dd>
            </div>
            <div className='sm:col-span-2 grid grid-cols-6'>
              <dt className='col-span-3 text-neutralColor-normal'>Construction</dt>
              <dd className='col-span-3 space-x-4'>
                <span>Start Date: {schedule3.startDate ? formatDate3(schedule3.startDate) : 'None'}</span>
                <span>Finish Date: {schedule3.finishDate ? formatDate3(schedule3.finishDate) : 'None'}</span>
              </dd>
            </div>
            <div className='sm:col-span-2 grid grid-cols-6'>
              <dt className='col-span-3 text-neutralColor-normal'>Lease Up</dt>
              <dd className='col-span-3 space-x-4'>
                <span>Start Date: {schedule4.startDate ? formatDate3(schedule4.startDate) : 'None'}</span>
                <span>Finish Date: {schedule4.finishDate ? formatDate3(schedule4.finishDate) : 'None'}</span>
              </dd>
            </div>
            <div className='sm:col-span-2 grid grid-cols-6'>
              <dt className='col-span-3 text-neutralColor-normal'>Exit</dt>
              <dd className='col-span-3 space-x-4'>
                <span>Start Date: {schedule5.startDate ? formatDate3(schedule5.startDate) : 'None'}</span>
                <span>Finish Date: {schedule5.finishDate ? formatDate3(schedule5.finishDate) : 'None'}</span>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}
